import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

export default function TotalSupply() {
  return 90000000;
}
